import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const registerCustomerReducer = (state: AppState, action: PayloadAction<string>) => {
  state.customerActionsChain.push(action.payload);
};

export default registerCustomerReducer;
